//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfHeader from "~/themes/fiskarsMoominDefault/components/components/organisms/SfHeader/SfHeader.vue";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfBadge from "~/themes/fiskarsMoominDefault/components/components/atoms/SfBadge/SfBadge.vue";
import SfIcon from "~/themes/fiskarsMoominDefault/components/components/atoms/SfIcon/SfIcon.vue";
import HeaderNavigation from "~/components/HeaderNavigation.vue";
import { useUiState, useUserAccount, useBloomreach } from "~/composables";
import {
  computed,
  useRouter,
  defineComponent,
  useRoute,
  onMounted,
  useContext,
} from "@nuxtjs/composition-api";
import { useVSFContext, onSSR } from "@vue-storefront/core";
import CategoryBreadcrumbs from "~/components/Category/CategoryBreadcrumbs.vue";
import { getBreadcrumbs } from "~/common";
import initializeDatadogRum from "~/helpers/logging/startDDRUM";
import initializeDatadogLogs from "~/helpers/logging/browser-logs";
import { checkCMSFlag } from '~/helpers/globalLabels';
import LocaleSelectorButton from "~/components/LocaleSelectorButton.vue";


export default defineComponent({
  name: "AppSimplifiedHeader",
  components: {
    LocaleSelectorButton,
    SfHeader,
    SfButton,
    SfBadge,
    CategoryBreadcrumbs,
    SfIcon,
    HeaderNavigation
  },
  props: {
    accountIcon: {
      type: [Object, String],
    },
    cartIcon: {
      type: [Object, String],
    },
    menu:{
      type:Object
    },
    benefitBarData: {
      type: Object,
    },
    cartTotalItems: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const {
      toggleCartSidebar,
      isMobileMenuOpen,
      toggleMobileMenu,
    } = useUiState();
    const { i18n, $config } = useContext();

    const route = useRoute();
    onMounted(async () => {
      checkAndUpdateCookie($config);
    });

    const { localePath } = useVSFContext();
    const { isAuthenticated } = useUserAccount('user-account-info');
    const { globalLabels, initMegaMenu, megaMenuContent } = useBloomreach("brx-simplified");
    const router = useRouter();
    const currentRoute = computed(() =>
      route?.value?.params?.pathMatch?.split("/")
    );

    const categoryBreadcrumbs = computed(() => {
      return getBreadcrumbs(currentRoute.value, localePath);
    });

    const handleAccountClick = async () => {
      if (!isAuthenticated) router.push(localePath(i18n.t("PAGES.LOGIN")));
      else router.push(localePath(i18n.t("PAGES.PERSONAL_DETAILS")));
    };

    const getCookie = (cname) => {
      var match = document.cookie.match(new RegExp('(^| )' + cname + '=([^;]+)'));
      if (match) return match[2];
    };

    const init_dd_script = (config) => {
      window.DD_RUM.setTrackingConsent('granted');
      window.DD_LOGS.setTrackingConsent('granted');
      // start the RUM
      initializeDatadogRum({
        DdrAppId: config.DdrAppId,
        DdrClientToken: config.DdrClientToken,
        DdrSite: config.DdrSite,
        DdrService: config.DdrService,
        DdrEnv: config.DdrEnv,
        CurrentEnv: config.CURRENT_ENV,
      });

      initializeDatadogLogs({
        DdrClientToken: config.DdrClientToken,
        DdrSite: config.DdrSite,
        DdrService: config.DdrService,
        CurrentEnv: config.CURRENT_ENV,
      });
    }

    const delete_dd_cookie = () => {
      if (getCookie("_dd_s")) {
        document.cookie = "_dd_s=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
    }

    const checkAndUpdateCookie = (config) => {
      var oneTrustConsent = getCookie('OptanonConsent');
      if(oneTrustConsent && decodeURIComponent(oneTrustConsent).indexOf('C0004:1') > -1) {
        init_dd_script(config);
      } else {
        window.DD_RUM.setTrackingConsent('not-granted');
        window.DD_LOGS.setTrackingConsent('not-granted');
        delete_dd_cookie()
        window.listenerEnableTryCounter = 1;
        var oneTrustEnablerInterval = setInterval(() => {
          if (window.listenerEnableTryCounter < 30) {
            if(window.OneTrust) {
              clearInterval(oneTrustEnablerInterval);
              window.OneTrust.OnConsentChanged(() => {
                if (window.OptanonActiveGroups.indexOf("C0004") > -1) {
                  init_dd_script(config);
                } else {
                  window.DD_RUM.setTrackingConsent('not-granted');
                  window.DD_LOGS.setTrackingConsent('not-granted');
                  delete_dd_cookie()
                }
              });
            } else {
              window.listenerEnableTryCounter++
            }
          } else {
            clearInterval(oneTrustEnablerInterval);
          }
        }, 1000);
      }
    }
    onSSR(async () => {
      await initMegaMenu(true);
    });

    const simplifiedHeader = checkCMSFlag('test-flag-simplified', 'true');

    return {
      isAuthenticated,
      simplifiedHeader,
      checkAndUpdateCookie,
      handleAccountClick,
      toggleCartSidebar,
      isMobileMenuOpen,
      toggleMobileMenu,
      categoryBreadcrumbs,
      megaMenuContent,
      globalLabels
    };
  },
});
